<template>
  <header class="border-b border-gray-200 px-4 py-3">
    <div class="flex items-center justify-between mx-auto">
      <!-- Left side - can add logo or other elements here -->
      <!-- Logo -->
      <div class="flex items-center justify-center gap-x-2">
        <img
            alt="Bison Mobile Logo"
            class="w-10 h-10"
            src="@/assets/img/Bison-bank-logo.png"
        />
        <span class="font-semibold text-2xl text-gray-500">Bison Mobile</span>
      </div>


      <!-- Right side - User menu -->
      <div class="flex items-center space-x-3">
        <!-- Mail icon -->
        <router-link to="/messages" class="p-2 text-primary hover:text-gray-700">
          <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1"
                  d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
          </svg>
        </router-link>

        <!-- User dropdown -->
        <div class="relative">
          <button
              @click="toggleDropdown"
              class="flex items-center space-x-2 text-gray-700 hover:text-gray-900 focus:outline-none"
          >
            <!-- GB Avatar -->
            <div
                class="w-8 h-8 bg-primary rounded-full flex items-center justify-center text-white text-sm font-medium">
              {{ initials.toUpperCase() }}
            </div>
            <!-- User name -->
            <span class="text-sm font-medium">Hello,  {{ user.name }}</span>
            <!-- Dropdown arrow -->
            <svg
                class="w-4 h-4 transition-transform duration-200"
                :class="{ 'rotate-180': isOpen }"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </button>

          <!-- Dropdown menu -->
          <div
              v-if="isOpen"
              class="absolute right-0 mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50"
          >
            <!-- My Data Section -->
            <div class="px-4 py-2">
              <h3 class="text-sm font-medium text-primary mb-2">My Data</h3>
              <ul class="space-y-1">
                <li>
                  <router-link to="#" class="block px-2 py-1 text-sm text-gray-700 hover:bg-gray-50 rounded">
                    View Personal Data
                  </router-link>
                </li>
                <li>
                  <router-link to="/setting/activity-log"
                               class="block px-2 py-1 text-sm text-gray-700 hover:bg-gray-50 rounded">
                    Activity Log
                  </router-link>
                </li>
                <li>
                  <router-link to="/operations" class="block px-2 py-1 text-sm text-gray-700 hover:bg-gray-50 rounded">
                    Pending Operations
                  </router-link>
                </li>
                <li>
                  <router-link to="#" class="block px-2 py-1 text-sm text-gray-700 hover:bg-gray-50 rounded">
                    Additional Information
                  </router-link>
                </li>
                <li>
                  <router-link to="#" class="block px-2 py-1 text-sm text-gray-700 hover:bg-gray-50 rounded">
                    Open Banking Authorizations
                  </router-link>
                </li>
              </ul>
            </div>

            <!-- Divider -->
            <hr class="my-2 border-gray-200">

            <!-- Other Settings Section -->
            <div class="px-4 py-2">
              <h3 class="text-sm font-medium text-primary mb-2">Other Settings</h3>
              <ul class="space-y-1">
                <li>
                  <router-link to="/setting/change-password"
                               class="block px-2 py-1 text-sm text-gray-700 hover:bg-gray-50 rounded">
                    Change Password
                  </router-link>
                </li>
                <li>
                  <router-link to="/setting/custom-account"
                               class="block px-2 py-1 text-sm text-gray-700 hover:bg-gray-50 rounded">
                    Customize Accounts
                  </router-link>
                </li>
                <li>
                  <router-link to="/setting/beneficiaries"
                               class="block px-2 py-1 text-sm text-gray-700 hover:bg-gray-50 rounded">
                    Frequent Beneficiaries
                  </router-link>
                </li>
                <li>
                  <router-link to="#" class="block px-2 py-1 text-sm text-gray-700 hover:bg-gray-50 rounded">
                    Manage SPIN
                  </router-link>
                </li>
              </ul>
            </div>

            <!-- Divider -->
            <hr class="my-2 border-gray-200">

            <!-- Help Section -->
            <div class="px-4 py-2">
              <h3 class="text-sm font-medium text-primary mb-2">Help</h3>
              <ul class="space-y-1">
                <li>
                  <router-link to="/contact-us" class="block px-2 py-1 text-sm text-gray-700 hover:bg-gray-50 rounded">
                    Contact Us
                  </router-link>
                </li>
                <li>
                  <router-link to="#" class="block px-2 py-1 text-sm text-gray-700 hover:bg-gray-50 rounded">
                    FAQs
                  </router-link>
                </li>
              </ul>
            </div>

            <!-- Divider -->
            <hr class="my-2 border-gray-200">

            <!-- Logout -->
<!--            <div class="px-4 py-2">-->
<!--              <button-->
<!--                  @click="handleLogout"-->
<!--                  class="flex items-center space-x-2 w-full px-2 py-1 text-sm text-primary hover:bg-gray-50 rounded"-->
<!--              >-->
<!--                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">-->
<!--                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"-->
<!--                        d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path>-->
<!--                </svg>-->
<!--                <span class="text-gray-700">Logout</span>-->
<!--              </button>-->
<!--            </div>-->

            <div class="px-4 py-2">
              <button
                  type="button"
                  @click.prevent="handleLogout"
                  class="flex items-center space-x-2 w-full px-2 py-1 text-sm text-primary hover:bg-gray-50 rounded">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path>
                </svg>
                <span class="text-gray-700">Logout</span>
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- Backdrop to close dropdown when clicking outside -->
    <div
        v-if="isOpen"
        @click="closeDropdown"
        class="fixed inset-0 z-40"
    ></div>
  </header>
</template>

<script setup>
import {ref, computed,onMounted, onUnmounted} from 'vue'
import {useRouter} from 'vue-router'
import { nextTick } from 'vue'

const router = useRouter()


const isOpen = ref(false)
const user = ref({ name: '' })

const toggleDropdown = () => {
  isOpen.value = !isOpen.value
}

const closeDropdown = () => {
  isOpen.value = false
}

const handleLogout = async () => {
  console.log('User logged out successfully')
  localStorage.removeItem('token')  // حذف توکن
  await nextTick()                  // صبر برای بروزرسانی DOM
  closeDropdown()                   // بستن منو
  router.push('/login')             // هدایت
}


// Close dropdown when pressing Escape key
const handleKeydown = (event) => {
  if (event.key === 'Escape') {
    closeDropdown()
  }
}

onMounted(() => {
  document.addEventListener('keydown', handleKeydown)
  const storedUser = localStorage.getItem('user')
  if (storedUser) {
    const parsed = JSON.parse(storedUser)
    // اگر در localStorage کل response ذخیره شده:
    user.value = parsed.user || parsed  // fallback اگر فقط user ذخیره شده
  }
})


const initials = computed(() => {
  const name = user.value?.name || ''
  if (!name) return ''
  const parts = name.split(' ')
  return ((parts[0]?.[0] || '') + (parts[1]?.[0] || '')).toUpperCase()
})


onUnmounted(() => {
  document.removeEventListener('keydown', handleKeydown)
})
</script>

<style scoped>
/* Additional custom styles if needed */
</style>